import React from 'react'
import { toJS } from 'mobx'

import Box from '../../components/basic/box'
import CustomInput from '../../components/basic/input'
import CustomButton from '../../components/basic/CustomButton'
import Logo from '../../components/basic/logo'
import CustomSnackbar from '../../components/global/snackbar'

import { api } from '../../functions/api'

import { inject, observer } from 'mobx-react'

import './index.scss'

const TIMEOUT = 3000
@inject('internal')
@inject('translate')
@observer
export default class LoginScreen extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loginBtnPressed: false,
            loading: false,
            email: null,
            password: null,
            passwordIsOk: null,
            emailIsOk: null,
            openSnackbar: false,
            vertical: 'bottom',
            horizontal: 'left',
            message: ''
        }

        this.email = null

        this.handleChange = this.handleChange.bind(this)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: '',
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    timeout = null
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    componentDidMount() {
        // this.setState({message:toJS(this.props.internal.dataSnackbar.msg), openSnackbar: toJS(this.props.internal.dataSnackbar.open)})
        this.props.internal.setSnackbar(
            toJS(this.props.internal.dataSnackbar.msg),
            toJS(this.props.internal.dataSnackbar.open)
        )
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.props.internal.setSnackbar('', false)
        }, 1000)

        this.turnOffSnackBar()
    }

    handleCloseSnackbar = () => {
        this.setState({ openSnackbar: false })
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: '',
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    login = async () => {
        let load_data = await api({
            method: 'post',
            url: 'login',
            params: {
                email: this.inputEmail.state.value,
                password: this.inputPassword.state.value
            }
        })

        // this.props.history.push("/")
        if (load_data.success === true) {
            if (load_data.data.data.access_token) {
                // this.props.internal.setSnackbar(load_data.data.message, true)
                this.props.internal.loginUser(load_data.data.data, false)
                localStorage.setItem('access_token', JSON.stringify(load_data.data.data))
                await this.getUserData()
                // this.props.internal.pushRoute("/");
            }
        } else if (load_data.success === false) {
            // this.setState({message: load_data.error.msg, openSnackbar: true})
            let message = load_data.data ? load_data.data.message : 'Error'
            this.props.internal.setSnackbar(message, true)
        }
        this.setState({ loading: false })
        this.turnOffSnackBar()
    }

    getUserData = async () => {
        let load_data = await api({
            method: 'get',
            url: 'user',
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            localStorage.setItem('user', JSON.stringify(load_data.data))
            this.props.internal.loginUser(load_data.data, true)
        }
    }

    handleLoginButton = () => {
        let emailData = this.inputEmail.getValid('email')
        // let passData = this.inputPassword.getValid('pass')

        // if (emailData.success && passData.success) {
        if (emailData.success) {
            this.setState({
                emailIsOk: true,
                passwordIsOk: true,
                loading: true
            })

            // API CALL
            //this.loginTest();
            this.login()
        } else {
            this.setState({ emailIsOk: false, passwordIsOk: false })
            //Nevyplnily ste všetký polia
            this.setState({ message: 'Nevyplnili ste všetký polia', openSnackbar: true })
            this.turnOffSnackBar()
        }
    }

    handleChange(data, property) {
        if (property === 'email') {
            this.setState({ email: data.target.value })
        } else if (property === 'password') {
            this.setState({ password: data.target.value })
        }
    }

    navigateTo = () => {
        // this.props.history.push('/reset');
        if (this.props.hasOwnProperty('history')) {
            this.props.history.push('/reset')
        } else {
            window.location.href = '/reset'
        }
    }

    render() {
        return (
            <div className={'container-with-logo'}>
                <CustomSnackbar
                    message={this.state.message}
                    open={this.state.openSnackbar}
                    classes={'snackbar-login'}
                />

                <Logo />
                <Box>
                    <h5>{this.props.translate.i18n.LOGIN.SIGN_IN}</h5>
                    {/* <h5>Prihlásiť sa</h5> */}
                    {/* {this.props.internal.getfullName}
                    {this.props.internal.user.firstName} */}

                    <CustomInput
                        //regex={regexes.email}
                        ref={ref => (this.inputEmail = ref)}
                        type={'email'}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                        // onChange={(data) => this.handleChange(data, "email")}
                        isValid={this.state.emailIsOk}
                        onPressButton={this.handleLoginButton}
                        pressedButton
                    />

                    <CustomInput
                        //regex={regexes.password}
                        ref={ref => (this.inputPassword = ref)}
                        type={'password'}
                        text={this.props.translate.i18n.LOGIN.INSERT_PASSWORD}
                        // onChange={(data) => this.handleChange(data, "password")}
                        isValid={this.state.passwordIsOk}
                        onPressButton={this.handleLoginButton}
                        pressedButton
                    />
                    <div className={'buttons'}>
                        <CustomButton
                            onClick={this.navigateTo}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.LOGIN.FORGOT_PASSWORD}
                            justText
                        />

                        <CustomButton
                            progressBar={this.state.loading}
                            onClick={this.handleLoginButton}
                            mystyle={'btn-orange-bg'}
                            title={this.props.translate.i18n.LOGIN.SIGN_IN}
                            justText
                            pressButton
                        />
                    </div>
                </Box>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/login/index.js